import React, { useState, useEffect } from 'react';
import { Typography, Box, makeStyles } from '@material-ui/core';
import { withNamespaces, Trans } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';
import Vintage from '../../../../../components/images/vintage09.png';

import { StraightStripes } from '../../../../../components/icons';

const useStyles = makeStyles((theme) => ({
	imageContainer: {
		position: 'absolute',
		background: `transparent url(${Vintage}) 0% 0% no-repeat padding-box`,
		mixBlendMode: 'multiply',
		width: '100%',
		height: '100%',
		backgroundSize: 'cover'
	},
	imageContainerFixed: {
		position: 'absolute',
		backgroundColor: '#DDE9E6',
		width: 701,
		height: 583,
		top: 103,
		left: 0,
		zIndex: 99,
		[theme.breakpoints.only('xs')]: {
			width: '100%',
			height: 300,
			left: 0,
			top: 0
		},
		[theme.breakpoints.only('md')]: {
			width: 560,
			height: 500,
			top: 200
		},
		[theme.breakpoints.only('sm')]: {
			width: 560,
			height: 500,
			top: 50,
			left: 0,
			right: 0
		}
	},
	pageContainer: {
		position: 'fixed',
		[theme.breakpoints.down('md')]: {
			position: 'absolute',
			width: '100%'
		},
		width: 1128,
		marginLeft: 'auto',
		marginRight: 'auto',
		right: 0,
		left: 0,
		top: 67,
		[theme.breakpoints.only('xs')]: {
			width: '100%'
		},
		[theme.breakpoints.only('sm')]: {
			width: '100%'
		},
		[theme.breakpoints.only('xl')]: {
			top: 200
		}
	},
	mainTitleBox: {
		top: 36,
		position: 'absolute',
		background: theme.palette.primary.dark,
		width: 600,
		left: 53,
		textAlign: 'left',
		zIndex: 101,
		[theme.breakpoints.only('xs')]: {
			width: '100%',
			top: 300,
			left: 0
		},
		[theme.breakpoints.only('md')]: {
			width: 600
		}
	},
	mainTitleText: {
		fontFamily: 'Bebas Neue',
		color: '#48B3C9',
		fontSize: '30px',
		letterSpacing: '0.30px',
		lineHeight: '30px',
		marginTop: 19,
		marginRight: 39,
		marginBottom: 11,
		marginLeft: 30,
		[theme.breakpoints.only('xs')]: {
			marginTop: 7,
			marginRight: 20,
			marginBottom: 3,
			marginLeft: 20,
			fontSize: 30,
			lineHeight: '30px',
			letterSpacing: '2px'
		}
	},
	halfStripes: {
		top: 0,
		left: 413,
		position: 'absolute',
		zIndex: 100,
		width: '400px',
		height: '252px',
		[theme.breakpoints.only('xs')]: {
			width: '100%',
			left: 0,
			top: 250
		},
		[theme.breakpoints.only('sm')]: {
			left: 'auto',
			right: 0
		}
	},
	descriptionContainer: {
		position: 'absolute',
		top: 211,
		width: 447,
		right: 0,
		zIndex: 100,
		[theme.breakpoints.only('xs')]: {
			top: 490,
			width: '100%'
		},
		[theme.breakpoints.only('sm')]: {
			top: 510,
			width: '100%'
		}
	},
	descriptionText: {
		textAlign: 'left',
		letterSpacing: '0.18px',
		fontSize: '18px',
		lineHeight: '30px',
		flexWrap: 'wrap',
		fontWeight: 'bold',
		[theme.breakpoints.only('xs')]: {
			marginRight: 20,
			marginLeft: 30
		},
		[theme.breakpoints.only('sm')]: {
			marginRight: 20,
			marginLeft: 30
		}
	}
}));

function MonumentHistory2(props) {
	const classes = useStyles();
	const { t } = props;
	const [showAnimation, setShowAnimation] = useState(props.showAnimation);
	useEffect(() => {
		if (props.showAnimation) {
			const timeOut = setTimeout(() => {
				setShowAnimation(props.showAnimation);
			}, 300);
			return () => clearTimeout(timeOut);
		}
		setShowAnimation(props.showAnimation);
	}, [props.showAnimation]);
	return (
		<Box className={classes.pageContainer}>
			<CSSTransition
				in={showAnimation}
				timeout={300}
				classNames='vintageimage5'
				unmountOnExit>
				<Box className={classes.imageContainerFixed}>
					<Box className={classes.imageContainer} />
				</Box>
			</CSSTransition>
			<CSSTransition
				in={showAnimation}
				timeout={300}
				classNames='ltrlong'
				unmountOnExit>
				<Box className={classes.mainTitleBox}>
					<Typography className={classes.mainTitleText}>
						<Trans i18nKey='monumhistory4.maintitle' />
					</Typography>
				</Box>
			</CSSTransition>
			<CSSTransition
				in={showAnimation}
				timeout={300}
				classNames='bttmiddle'
				unmountOnExit>
				<Box className={classes.descriptionContainer}>
					<Typography className={classes.descriptionText}>
						<Trans i18nKey='monumhistory4.description' />
					</Typography>
				</Box>
			</CSSTransition>

			<CSSTransition
				in={showAnimation}
				timeout={300}
				classNames='rtllong'
				unmountOnExit>
				<Box className={classes.halfStripes}>
					<StraightStripes width='100%' height='100%' />
				</Box>
			</CSSTransition>
		</Box>
	);
}

export default withNamespaces('monumentHistory')(MonumentHistory2);
